import { GraphQLClient } from 'graphql-request';
export var DATOCMS_ENDPOINT = "production" === 'production' ? 'https://graphql.datocms.com/' : 'https://graphql.datocms.com/preview';
export var DATOCMS_HEADERS = {
    Authorization: "Bearer ".concat(process.env.NEXT_PUBLIC_DATOCMS_API_KEY)
};
var client = new GraphQLClient(DATOCMS_ENDPOINT, {
    headers: DATOCMS_HEADERS
});
export default client;
